"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuditresultsummaryController = function AuditresultsummaryController($http, $scope, DTOptionsBuilder, DTColumnBuilder, Constants, CONST, User, materialButtons, datePicker, $rootScope, FunctionService, $location, EpisodeDrgAuditTypeService, QueryModalOptions) {
  _classCallCheck(this, AuditresultsummaryController);

  $http.defaults.headers.common["Authorization"] = "Bearer " + $rootScope.globals.currentUser.token;
  this.datatableApi;
  this.user = User.getUser();
  this.datatableApi;
  this.name = "Audit Result Summary";
  this.episodeValue = "";
  this.specialtyString = "";
  this.separationString = "";
  this.fixedValue = "";
  this.locale = "en-au";
  this.url = WEBSERVICEURL + "/dataagility/api/service.auditresultsummary?";
  this.initUrl = this.url + "&startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L");

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.functionSettings = response.functionSettings;
    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;

    // All Private Clients should be active, All Public should be inactive
    if ($scope.vm.episodeValue === "$") {
      console.log("WIES vars set to private");
      $scope.vm.wiesDefault = "0.00";
      $scope.vm.wiesParseAmount = 2;
    } else {
      console.log("WIES vars set to public");
      $scope.vm.wiesDefault = "0.0000";
      $scope.vm.wiesParseAmount = 4;
    }

    $scope.vm.functionSettings = response.functionSettings;

    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
        return x.mData === "drgVersion";
      });
      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
    }

    Constants.campusData().then(function successCallback(response) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        var campusOptions = [];
        if (typeof $scope.vm.user.campus === "string") {
          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
        } else {
          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
        }
        $scope.vm.campusOptions = campusOptions;
        $scope.vm.campus.selectedCampus = campusOptions;
      } else {
        $scope.vm.campusOptions = response;
      }
      filterCampus($scope.vm.campusOptions);
    });
  });

  materialButtons.render();
  materialButtons.processing();

  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    // setup search filters
    search();

    // set the table to a fixed height, so it never collapsed up and down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  $scope.drawCallback = function (nRow) {
    var table = $("#auditTable").DataTable();

    // Sum the values in the WIES Change column
    var sumWiesChange = table.column(getIndexOfColumn("wiesDiff")).data().reduce(function (a, b) {
      return parseFloat(a) + parseFloat(b);
    }, 0).toFixed($scope.vm.wiesParseAmount);
    // Display in header
    $(".reports__stats #total-wies-change").html($scope.vm.episodeValue + " Difference sum: <strong>" + sumWiesChange + "</strong>");

    var dischargeSpecialtiesCount = 0;
    var querySpecialtiesCount = 0;

    angular.forEach(table.column(4).data(), function (value) {
      if (angular.isString(value)) {
        // If the Query Specialty cell is empty, increment dischargeSpecialtiesCount
        dischargeSpecialtiesCount += value === "" ? 1 : 0;
        // Otherwise increment querySpecialtiesCount
        querySpecialtiesCount += value === "" ? 0 : 1;
      }
    });

    // Display in header
    $(".reports__stats #total-specialty").html($scope.vm.specialtyString.charAt(0) + $scope.vm.specialtyString.substr(1).toLowerCase() + " count: <strong>" + dischargeSpecialtiesCount + "</strong>");
    $(".reports__stats #total-querySpecialty").html("Query " + $scope.vm.specialtyString.toLowerCase() + " count: <strong>" + querySpecialtiesCount + "</strong>");
  };

  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
    headers: {
      Authorization: "Bearer " + $rootScope.globals.currentUser.token
    },
    url: $scope.vm.initUrl,
    type: "GET",
    error: function error(xhr, _error, thrown) {
      if (thrown == "Unauthorized") {
        //window.location.replace(window.location.origin + '/login');
        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
      }
    }
  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($("#auditTable").DataTable());
  }).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: "print",
    text: ""
  }, {
    extend: "csvHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: "excelHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: "",
    action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]);

  function yesNo(data) {
    return data === true ? "Y" : "N";
  }

  this.dtColumns = [DTColumnBuilder.newColumn("episodeQueryId").withTitle("Query ID").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("querySpecialty").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditType").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("queryTemplateName").withTitle("Query Type").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("queryStatus").withTitle("Query Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    switch (data) {
      case "true":
        return "Complete";
      case "false":
        return "Open";
      default:
        return data;
    }
  }), DTColumnBuilder.newColumn("updatedDate").withTitle("Updated Date").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data) {
    return data ? moment(new Date(data)).format('DD/MM/YYYY HH:MM') : '';
  }), DTColumnBuilder.newColumn("currentDRGDescription").withTitle("Current DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("currentWies").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
  }), DTColumnBuilder.newColumn("wiesDiff").withTitle("Loading...").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
  }), DTColumnBuilder.newColumn("auditFinalisedDateTime").withTitle("Date Finalised").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data) {
    return data ? moment(new Date(data)).format('DD/MM/YYYY HH:MM') : '';
  }), DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("originalCoder").withTitle("Original Coder").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric")];

  // Search filters
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = [];

  this.queryStatus = {
    selectedQueryStatus: []
  };
  this.queryStatusOptions = [];

  QueryModalOptions.statuses().then(function (response) {
    angular.forEach(response, function (item, key) {
      $scope.vm.queryStatusOptions.push(item.name);
    });
  });

  this.auditType = {
    selectedAuditType: []
  };
  this.initAuditTypeOptions = [];
  this.auditTypeOptions = [];

  this.specialty = {
    selectedSpecialty: []
  };
  this.specialtyOptions = {};

  this.querySpecialty = {
    selectedQuerySpecialty: []
  };

  QueryModalOptions.types().then(function successCallback(response) {
    angular.forEach(response, function (value, key) {
      $scope.vm.auditTypeOptions.push(value.name);
      $scope.vm.initAuditTypeOptions.push(value.name);
    });
  });

  Constants.campusData().then(function successCallback(response) {
    $scope.vm.campusOptions = response;
    filterCampus($scope.vm.campusOptions);
  });

  Constants.getDivisionAndSpecialtyData().then(function (response) {
    $scope.vm.specialtyOptions = response.specialties;
    filterSpecialty(response.specialties);
    // Can load divisions if needed??
  });

  this.startDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "months").startOf("month"),
      dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
    }
  };
  this.endDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "days"),
      dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
    }
  };

  // Populate the audit type options for the current environment
  $scope.getAuditType = function () {
    EpisodeDrgAuditTypeService.types().then(function successCallback(response) {
      angular.forEach(response, function (value, key) {
        $scope.vm.auditTypeOptions.push(value.name);
      });
    }, function errorCallback(response) {
      // $scope.feedback = "Error loading data";
      if (response.status === 401) {
        window.location.replace(window.location.origin + "/login?logout=true");
      }
    });
  };

  $scope.getAuditType();

  // callbacks for lx-selects and lx-date-picker
  this.specialtyCallback = specialtyCallback;
  datePicker.autoClose($scope);

  function setDtHeaders(table) {
    $(table.column(getIndexOfColumn("dischargeDate")).header()).html($scope.vm.separationString + " Date");
    $(table.column(getIndexOfColumn("speciality")).header()).html($scope.vm.specialtyString);
    $(table.column(getIndexOfColumn("querySpecialty")).header()).html("Query " + $scope.vm.specialtyString);
    $(table.column(getIndexOfColumn("auditType")).header()).html($scope.vm.functionSettings.QueryModalQueryType && $scope.vm.functionSettings.QueryModalQueryType.isActive ? "Query By" : "Audit Type");
    $(table.column(getIndexOfColumn("currentWies")).header()).html("Current " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn("wiesDiff")).header()).html($scope.vm.episodeValue + " Difference");
  }

  function getIndexOfColumn(columnName) {
    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === columnName;
    });
    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
  }

  function specialtyCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  function filterAuditType(swap) {
    $scope.vm.auditType.selectedAuditType = [];
    if (swap === "add") {
      $scope.vm.auditType.selectedAuditType = $scope.vm.auditTypeOptions;
    }
  }

  function filterQueryStatus(modifier) {
    $scope.vm.queryStatus.selectedQueryStatus = [];
    if (modifier === "add") {
      $scope.vm.queryStatus.selectedQueryStatus = $scope.vm.queryStatusOptions;
    }
  }

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = [];
    if (modifier === "add") {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
    }
  }

  function filterSpecialty(swap) {
    $scope.vm.specialty.selectedSpecialty = [];
    if (swap === "add") {
      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
    }
  }

  function filterQuerySpecialty(swap) {
    $scope.vm.querySpecialty.selectedQuerySpecialty = [];
    if (swap === "add") {
      $scope.vm.querySpecialty.selectedQuerySpecialty = $scope.vm.specialtyOptions;
    }
  }

  function checkParam(param) {
    if (param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  $scope.vm.changeData = changeData;

  function changeData() {
    if ($scope.vm.datatableApi) {
      var campus = "";
      if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
          campus = $scope.vm.user.campus;
        } else {
          campus = $scope.vm.campus.selectedCampus;
        }
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
      var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&querySpecialty=" + checkParam($scope.vm.querySpecialty.selectedQuerySpecialty) + "&auditType=" + checkParam($scope.vm.auditType.selectedAuditType) + "&queryStatus=" + checkParam($scope.vm.queryStatus.selectedQueryStatus) + "&campus=" + checkParam(campus);
      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
    }
  }

  function search() {
    // delete any global searches previously applied
    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

    var auditTable = $scope.vm.datatableApi;
    var clearAuditTable = auditTable.search("").draw();

    filterAuditType("minus");
    filterSpecialty("minus");
    filterCampus("minus");
    filterQuerySpecialty("minus");
    filterQueryStatus("minus");

    // re-draw tabele on datepicker close
    $scope.$on("lx-date-picker__close-start", function (e, id) {
      $scope.vm.changeData();
    });
  }

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }

  // bind filter swap
  this.filterSwap = filterSwap;

  function filterSwap(thisFilter, thisModifier) {
    switch (thisFilter) {
      case "campus":
        if (thisModifier === "add") {
          filterCampus("add");
        } else {
          filterCampus("minus");
        }

        break;

      case "auditType":
        if (thisModifier === "add") {
          filterAuditType("add");
        } else {
          filterAuditType("minus");
        }

        break;

      case "queryStatus":
        if (thisModifier === "add") {
          filterQueryStatus("add");
        } else {
          filterQueryStatus("minus");
        }

        break;

      case "specialty":
        if (thisModifier === "add") {
          filterSpecialty("add");
        } else {
          filterSpecialty("minus");
        }

        break;

      case "querySpecialty":
        if (thisModifier === "add") {
          filterQuerySpecialty("add");
        } else {
          filterQuerySpecialty("minus");
        }

        break;

      default:
        break;
    }
  }
};

exports.default = AuditresultsummaryController;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditresultsummary/auditresultsummary.controller.js